import { createSlice } from "@reduxjs/toolkit";
import getMeristemDefaultValue from "@utils/meristemContext/meristemContextDefaults";

const routeSlice = createSlice({
  name: "routeId",
  initialState: getMeristemDefaultValue()?.route_id,
  reducers: {
    setRouteId(state, action) {
      return action.payload || state;
    },
  },
});

export const { setRouteId } = routeSlice.actions;

export default routeSlice.reducer;
